export const checkTableAuth = (tableType, accountRole, roleTableAuth, authLevel) => {
  let ret = false;

  if (accountRole && accountRole.flagSuperAdmin) {
    ret = true;
  } else if (roleTableAuth && roleTableAuth.length) {
    roleTableAuth.forEach(tableAuth => {
      if (tableAuth && tableAuth.tableType === tableType && tableAuth.authLevel >= authLevel) {
        ret = true;
      }
    });
  }

  return ret;
}

export const checkPageAuth = (props, accountRole, roleTableAuth) => {
  const { history, forwardLogin } = props;

 if (checkTableAuth('rf_map', accountRole, roleTableAuth, 1)) {
    history.push(window.CONFIG.WEB_ROOT + "/rf_map/project");
  } else {
    forwardLogin("Sorry yon can't access this page.");
    history.push(window.CONFIG.WEB_ROOT + "/Login" );
  }
}